<template>
  <div class="mobile-device">
    <div class="content">
      <div id="body" class="preview" v-if="value.mode === 'preview'">
        <div class="box">
          <h4 class="title">Você falará com:</h4>
          <h1 class="business-title">{{title || 'Título'}}</h1>
          <div class="business-description">{{description || 'Descrição'}}</div>
          <button class="btn" id="btn">
            {{buttonText}}
          </button>
          <small v-if="!isActivePlan">
            Uma solução <strong>zaper.in</strong>
          </small>
        </div>
      </div>
      <div id="body" class="direct" v-else>
        <div class="loading">
          <div class="dot-pulse"></div>
          <span class="text">Por favor, aguarde...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  props: ['value'],
  computed: {
    buttonText () {
      if (this.value.url.indexOf('https://wa.me') === 0) {
        return 'Fale pelo WhatsApp'
      } else if (this.value.url.indexOf('https://t.me') === 0) {
        return 'Fale pelo Telegram'
      } else if (this.value.url.indexOf('https://m.me') === 0) {
        return 'Fale pelo Messenger'
      } else if (this.value.url.indexOf('tel:') === 0) {
        return 'Ligar agora'
      } else if (this.value.url.indexOf('mailto:') === 0) {
        return 'Enviar email'
      } else if (this.value.url.indexOf('ifood.com.br') > -1) {
        return 'Ir para o iFood'
      } else {
        return 'Acesse'
      }
    },
    title () {
      return this.value.title || 'Negócio'
    },
    description () {
      return this.value.description || 'Descrição'
    },
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      project: 'projects/getSelected'
    }),
    isActivePlan () {
      if (!this.user) {
        return false
      }

      return moment(this.user.active_plan_at || 0).valueOf() > Date.now() || this.user.id !== this.project.user_id
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-device  {
  width: 400px;
  height: 600px;
  overflow-y: auto;
  background-color: white;

  .content {
    font-family: 'Rubik', sans-serif;
    height: 100%;
    width: 100%;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    text-rendering: optimizeLegibility !important;
    font-size: 16px;
    color: #717171;

    #body {
      height: 100%;
      width: 100%;

      &.preview {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      &.direct {
        color: #000;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;

        .loading {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .loading .text {
          margin-top: 20px;
        }

        .dot-pulse {
          position: relative;
          left: -9999px;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: #00C57E;
          color: #00C57E;
          box-shadow: 9999px 0 0 -10px #00C57E;
          animation: dotPulse 1.5s infinite linear;
          animation-delay: .25s;
        }

        .dot-pulse::before, .dot-pulse::after {
          content: '';
          display: inline-block;
          position: absolute;
          top: 0;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: #00C57E;
          color: #00C57E;
        }

        .dot-pulse::before {
          box-shadow: 9980px 0 0 -10px #00C57E;
          animation: dotPulseBefore 1.5s infinite linear;
          animation-delay: 0s;
        }

        .dot-pulse::after {
          box-shadow: 10014px 0 0 -10px #00C57E;
          animation: dotPulseAfter 1.5s infinite linear;
          animation-delay: .5s;
        }

        @keyframes dotPulseBefore {
          0% {
            box-shadow: 9980px 0 0 -10px #00C57E;
          }
          30% {
            box-shadow: 9980px 0 0 2px #00C57E;
          }
          60%,
          100% {
            box-shadow: 9980px 0 0 -10px #00C57E;
          }
        }

        @keyframes dotPulse {
          0% {
            box-shadow: 9999px 0 0 -10px #00C57E;
          }
          30% {
            box-shadow: 9999px 0 0 2px #00C57E;
          }
          60%,
          100% {
            box-shadow: 9999px 0 0 -10px #00C57E;
          }
        }

        @keyframes dotPulseAfter {
          0% {
            box-shadow: 10018px 0 0 -10px #00C57E;
          }
          30% {
            box-shadow: 10018px 0 0 2px #00C57E;
          }
          60%,
          100% {
            box-shadow: 10018px 0 0 -10px #00C57E;
          }
        }
      }
    }


    #body .box {
      max-width: 350px;
      padding: 15px;
      padding-top: 50px;
      padding-bottom: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    #body .box .title {
      color: #21C59E;
      font-weight: bold;
    }

    #body .box .business-title {
      margin-top: 60px;
      font-weight: bold;
      font-size: 2em;
      margin-bottom: 20px;
    }

    #body .box .business-description {
      font-size: 1.1em;
      line-height: 1.3;
      word-break: break-all;
    }

    #body .box .btn {
      margin-top: 60px;
      background-color: #21C59E;
      color: white;
      font-weight: bold;
      border: none;
      border-radius: 3px;
      padding: 15px;
      width: 100%;
      max-width: 250px;
    }

    #body .box small {
      margin-top: 60px;
    }
  }
}
</style>